import { MEMBER } from "@src/mock/data/member";

export default {
  title: '編輯會員',
  type: 'post',
  body: [
    {
      title: '成功',
      body: {
        "code": 200,
        "message": "success",
        "status": "SUCCESS",
        "data": {
          "items": MEMBER,
        }
      }
    },
  ]
}

